
  export default {
    name: 'About',
    created(){
        document.title = "Basseliersstraat"
    }
  }
